module.exports = require("@cloudbase/wx-cloud-client-sdk");